import { ParameterType } from '@/study-search/enums';

import { Filter } from '../models/filter';
import { BaseRouteHandler } from './BaseRouteHandler';
import { IRouteHandler } from './IRouteHandler';
import RoutingDefinitions from './RoutingDefinitions';

export class DisciplineEducationalFormCountryRouteHandler extends BaseRouteHandler implements IRouteHandler {
	public canHandle(filters: Filter[]): boolean {
		const indexableFilters = filters.filter((_) => _.canBeIndexed());

		return (
			indexableFilters.length === 3 &&
			indexableFilters.some((_) => _.type === ParameterType.DISCIPLINES) &&
			indexableFilters.some((_) => _.type === ParameterType.EDUCATIONAL_FORM) &&
			indexableFilters.some((_) => _.type === ParameterType.COUNTRY)
		);
	}

	protected selectRoute(filters: Filter[]): any {
		return {
			name: RoutingDefinitions.DISCIPLINE_EDUCATIONAL_FORM_COUNTRY_ROUTE,
			params: {
				discipline: this.extractPath(filters.find((_) => _.type === ParameterType.DISCIPLINES)),
				educational_form: this.extractPath(filters.find((_) => _.type === ParameterType.EDUCATIONAL_FORM)),
				country: this.extractPath(filters.find((_) => _.type === ParameterType.COUNTRY)),
			},
		};
	}
}
